module.exports = __webpack_public_path__ + "static/img/airpods_pro_case.0677e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/GoodsShow/AirPods Pro/imgs/airpods_pro_case.png
// module id = 5rlS
// module chunks = 0